// components/Blocks/BenefitsBlock.js
import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import benefits_img from '../../../../../../../img/passport.svg';
import FileUploader from '../../../../../../../components/FileUpload/FileUploader';

const BenefitsBlock = ({ 
  data, 
  onChange, 
  editable, 
  defaultOpen = false, 
  benefitsList = [], 
  isViewOnly = false,
  onFileViewRequest
}) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  const handleFieldChange = (field, value) => {
    if (isViewOnly) return;
    onChange(field, value);
  };

  const handleFilesChange = (files) => {
    if (isViewOnly) return;
    
    // Добавляем информацию о секции к каждому файлу
    const filesWithSection = files.map(file => ({
      ...file,
      section: 'benefits'
    }));
    
    onChange('benefitFiles', filesWithSection);
  };

  const handleFileView = (file) => {
    onChange('benefitFileView', file);
  };

  const handleFileDownload = (file) => {
    onChange('benefitFileDownload', file);
  };

  const subtitle = data.benefitDescription || 'немає';

  return (
    <div className="card-block">
      <button
        className="block-header"
        onClick={() => setIsOpen(!isOpen)}
      >
        <div className="left">
          <img className="blk-icon" src={benefits_img} alt="" />
          <span className="title">Пільги</span>
          {!isOpen && <span className="subtitle">{subtitle}</span>}
        </div>
        <FontAwesomeIcon 
          icon={isOpen ? faChevronUp : faChevronDown} 
          className="chevron" 
        />
      </button>
      {isOpen && (
        <div className="block-body">
          <div className="row g-3 align-items-start">
            <div className="col-md-6">
              <div className="form-label">Вид пільги</div>
              <select
                className="form-select"
                value={data.benefitId || ''}
                onChange={(e) => {
                  handleFieldChange('benefitId', e.target.value);
                  const benefit = benefitsList.find(b => b._id === e.target.value);
                  handleFieldChange('benefitDescription', benefit?.name || '');
                }}
                disabled={isViewOnly || !editable}
              >
                <option value="">Оберіть пільгу</option>
                {benefitsList.map(benefit => (
                  <option key={benefit._id} value={benefit._id}>
                    {benefit.name}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-md-6">
              <div className="form-label">Документ</div>
              <input
                type="text"
                className="form-control"
                value={data.benefitDocument}
                onChange={(e) => handleFieldChange('benefitDocument', e.target.value)}
                disabled={isViewOnly || !editable}
              />
            </div>
            <div className="col-md-6">
              <div className="form-label">Дата видачі</div>
              <input
                type="date"
                className="form-control"
                value={data.benefitDocumentDate}
                onChange={(e) => handleFieldChange('benefitDocumentDate', e.target.value)}
                disabled={isViewOnly || !editable}
              />
            </div>
            <div className="col-md-6">
              <div className="form-label">Номер документа</div>
              <input
                type="text"
                className="form-control"
                value={data.benefitDocumentNumber}
                onChange={(e) => handleFieldChange('benefitDocumentNumber', e.target.value)}
                disabled={isViewOnly || !editable}
              />
            </div>
            <div className="col-md-6">
              <div className="form-label">Видано</div>
              <input
                type="text"
                className="form-control"
                value={data.benefitDocumentIssuedBy}
                onChange={(e) => handleFieldChange('benefitDocumentIssuedBy', e.target.value)}
                disabled={isViewOnly || !editable}
              />
            </div>
            <div className="col-md-6">
              <div className="form-label">Пільга по харчуванню</div>
              <div>{data.benefitKitchenName}</div>
            </div>
          </div>

          {/* Используем FileUploader напрямую */}
          <FileUploader
            label="Завантажте файли"
            description="Файли у форматі PDF, JPG, PNG. Максимальний розмір файлу 2 МБ."
            value={data.benefitFiles || []}
            onChange={handleFilesChange}
            onFileView={handleFileView}
            onFileDownload={handleFileDownload}
            editable={editable}
            disabled={isViewOnly || !editable}
            multiple={true}
            maxCount={10}
            asBase64={true}
            onFileViewRequest={onFileViewRequest}
          />
        </div>
      )}
    </div>
  );
};

export default BenefitsBlock;